<template>
  <div class="flex-v-center mb-2">
    <div class="avatar-holder mr-1">
      <img :src="profile.avatar || $avatars[profile.defaultAvatarId || 13]" alt="avatar">
    </div>
    <div>
      <button class="btn btn-outline" @click="$emit('showchooseavatar')">{{ $lang.messages.add_profile.choose_avatar }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadAvatar",
  props: ['profile'],
}
</script>

<style scoped>

</style>